import React, { useState } from 'react';
import API from '../api';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { setPriceCodeSettings } from '../utils/priceCode';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post('/auth/login', { email, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      try {
        const profileRes = await API.get('/auth/profile');
        localStorage.setItem('shopProfile', JSON.stringify(profileRes.data));
        setPriceCodeSettings(
          profileRes.data.price_code_enabled || false,
          profileRes.data.price_code_data?.digit_map || {},
          profileRes.data.price_code_data?.zero_letters || ['', ''],
          profileRes.data.price_code_data?.repeat_letter || '',
          profileRes.data.price_code_scope || 'everything'
        );
      } catch (profileErr) {
        console.error('Failed to load profile settings', profileErr);
      }
      toast.success('Login successful!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = 'https://billsaas-uncle-backend.onrender.com/api/auth/google';
  };

  return (
    <div style={styles.container} className="container">
      <div style={styles.card}>
        
        <div style={styles.logoSection}>
  <img src="/logo.png" alt="Wahi POS" style={styles.logo} />
</div>

        <button onClick={handleGoogleLogin} style={styles.googleBtn}>
          <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: '20px', height: '20px' }} />
          Continue with Google
        </button>

        <div style={styles.divider}>
          <div style={styles.dividerLine}></div>
          <span style={styles.dividerText}>or</span>
          <div style={styles.dividerLine}></div>
        </div>

        <form onSubmit={handleLogin}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">Login</button>
          <div style={{ textAlign: 'right', marginTop: '0.5rem' }}>
            <Link to="/forgot-password" style={styles.forgotLink}>Forgot Password?</Link>
          </div>
        </form>

        <div style={styles.signupRow}>
          <span style={{ color: '#888', fontSize: '14px' }}>Don't have an account?</span>
          <Link to="/signup" style={styles.signupLink}>Sign up</Link>
        </div>

      </div>
    </div>
  );
};

const styles = {
  container: { 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh', 
    background: '#f5f5f7',
    padding: '1rem',
  },
  card: { 
    background: '#fff', 
    padding: '2.5rem 2rem', 
    borderRadius: '16px', 
    width: '100%', 
    maxWidth: '420px', 
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  logoSection: { 
    textAlign: 'center', 
    marginBottom: '0rem',
  },
  logo: { 
    height: '180px',
    objectFit: 'contain',
    marginBottom: '0',
  },
  googleBtn: { 
    width: '100%', 
    padding: '12px', 
    background: '#fff', 
    color: '#333', 
    border: '1.5px solid #e0e0e0', 
    borderRadius: '10px', 
    fontSize: '15px', 
    cursor: 'pointer', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    gap: '10px', 
    marginBottom: '1.5rem', 
    fontWeight: '500',
    transition: 'background 0.2s',
  },
  divider: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '1rem', 
    marginBottom: '1.5rem',
  },
  dividerLine: { 
    flex: 1, 
    height: '1px', 
    background: '#e0e0e0',
  },
  dividerText: { 
    color: '#aaa', 
    fontSize: '13px',
    whiteSpace: 'nowrap',
  },
  input: { 
    width: '100%', 
    padding: '12px 14px', 
    marginBottom: '1rem', 
    borderRadius: '10px', 
    border: '1.5px solid #e0e0e0', 
    fontSize: '15px', 
    boxSizing: 'border-box',
    outline: 'none',
    color: '#333',
  },
  button: { 
    width: '100%', 
    padding: '13px', 
    background: '#4f46e5', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '10px', 
    fontSize: '16px', 
    cursor: 'pointer',
    fontWeight: '600',
    letterSpacing: '0.3px',
  },
  forgotLink: { 
    fontSize: '13px', 
    color: '#4f46e5',
    textDecoration: 'none',
  },
  signupRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    marginTop: '1.5rem',
  },
  signupLink: {
    color: '#4f46e5',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '600',
  },
};

export default Login;